// src/firebase/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"; // Si vas a usar base de datos
import { getAuth } from "firebase/auth";           // Si vas a usar usuarios

const firebaseConfig = {
  apiKey: "AIzaSyCBi6iPON4F7a0t9jJapBkZ2Gd28fD1_h4",
  authDomain: "dulce-como-vos-80afc.firebaseapp.com",
  projectId: "dulce-como-vos-80afc",
  storageBucket: "dulce-como-vos-80afc.firebasestorage.app",
  messagingSenderId: "505492849802",
  appId: "1:505492849802:web:b52789438ddf45956e1973",
  measurementId: "G-V03P6YMZJ3"
};
// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar los servicios para usarlos en tus componentes
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;